(function(angular){
	'use strict';
	
	var planCardObject = {
		templateUrl: [
			'STATIC_BASE_PATH', 
			templateUrlFunction
		],
		bindings: {
			cardTitle: '<',
			context: '@?',
			ctaCallback: '&?',
			ctaDisabled: '<?',
			customCtaText: '@?',
			funnel: '@?',
			hideCta: '<?',
			includeBars: '@',
			includeModule: '<',
			isClickable: '<?',
			riaPlanName: '@?',
			soldOut: '<?',
			smallCtaText: '<?'
		},
		controller: [
			'PlanCardFactory',
			PlanCardFunction
		],
		controllerAs: 'planCard'
	};
	
	angular
		.module('planModule')
		.component('planCard', planCardObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/shared/plans/plan-card.html';
	}
	
	function PlanCardFunction(
		PlanCardFactory
	){
		var planCard = this;

		planCard.$onInit = function() {
			if(angular.isUndefined(planCard.includeModule)) {
				planCard.includeModule = true;
			}

			if (planCard.isClickable) {
				planCard.smallCtaText = true;
			}

			planCard.card = PlanCardFactory.getPlanCardData()[planCard.cardTitle];
			planCard.url = PlanCardFactory.getUrl(planCard.cardTitle, '/investments');

			if (planCard.funnel === 'marketing' && planCard.context === 'chooseAdvancedPlan') {
				planCard.url = PlanCardFactory.getUrl(planCard.cardTitle, '/start-investing');
			}
		};
	}
})(window.angular);